export const responseDataLakeStorages = {
  data: {
    attributes: {
      path: '/ebs/ftpd/test-1640084082099-000001'
    },
    id: 959
  }
};